package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.autoResponsiveness

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.AppConstantsEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.domain.util.toTwoDecimalString
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.jetbrains.compose.web.css.px

@Composable
fun PriceInCafe(
    windowSizeMode: WindowSizeModeEnum,
    priceInCafe: List<Double?>?,
    selectedVat2: String?,
    countryId: String,
    updateVatCode2: (String) -> Unit,
    updatePriceInCafe: (List<Double?>) -> Unit,
    priceLevels: List<String?>?,
) {
    Row(
        modifier = Modifier.autoResponsiveness()
    ) {
        val price1 = priceInCafe?.getOrNull(0)
        val price2 = priceInCafe?.getOrNull(1)
        val price3 = priceInCafe?.getOrNull(2)

        CustomEditText(
            modifier = Modifier,
            marginBottom =Dimen.highLargePadding,
            marginRight = if (windowSizeMode==WindowSizeModeEnum.PHONE) 0.px
                else Dimen.largePadding,
            width = Dimen.normalEditTextWidth2,
            height = Dimen.mediumOutlinedEditTextHeight,
            label = priceLevels?.getOrNull(0) ?: (Strings.current().price + " " + 0),
            isOutlinedEditText = true,
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            textAlign = TextAlign.End,
            value = price1.toTwoDecimalString(useDotDigitStatus(countryId)),
            isDecimal = true,
            isRequired = false,
            usingDotForDigit = useDotDigitStatus(countryId),
            onFocusIn = {},
            onFocusOut = { inputValue ->
                val prices = arrayListOf<Double?>()
                prices.add(safeStringToDouble(inputValue))
                prices.add(price2)
                prices.add(price3)
                updatePriceInCafe(prices)
            },
            onInputChange = {it, validation -> }
        )

        CustomEditText(
            modifier = Modifier,
            marginBottom = Dimen.highLargePadding,
            marginRight = if (windowSizeMode==WindowSizeModeEnum.PHONE) 0.px
                else Dimen.largePadding,
            width = Dimen.normalEditTextWidth2,
            height = Dimen.mediumOutlinedEditTextHeight,
            label =priceLevels?.getOrNull(1)?:Strings.current().price1,
            isOutlinedEditText = true,
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            textAlign = TextAlign.End,
            value = price2.toTwoDecimalString(useDotDigitStatus(countryId)),
            isDecimal = true,
            isRequired = false,
            usingDotForDigit = useDotDigitStatus(countryId),
            onFocusIn = {},
            onFocusOut = { inputValue ->
                val prices = arrayListOf<Double?>()
                prices.add(price1)
                prices.add(safeStringToDouble(inputValue))
                prices.add(price3)
                updatePriceInCafe(prices)
            },
            onInputChange = {it, validation -> }
        )

        CustomEditText(
            modifier = Modifier ,
            marginBottom =Dimen.highLargePadding,
            marginRight = if (windowSizeMode==WindowSizeModeEnum.PHONE) 0.px
                else Dimen.largePadding,
            width = Dimen.normalEditTextWidth2,
            height = Dimen.mediumOutlinedEditTextHeight,
            label =priceLevels?.getOrNull(2)?:Strings.current().price2,
            isOutlinedEditText = true,
            textAlign = TextAlign.End,
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            value = price3.toTwoDecimalString(useDotDigitStatus(countryId)),
            isDecimal = true,
            isRequired = false,
            usingDotForDigit = useDotDigitStatus(countryId),
            onFocusIn = {},
            onFocusOut = { inputValue ->
                val prices = arrayListOf<Double?>()
                prices.add(price1)
                prices.add(price2)
                prices.add(safeStringToDouble(inputValue))
                updatePriceInCafe(prices)
            },
            onInputChange = {it, validation -> }
        )


        DropDownItem(
            modifier = Modifier
                .margin(bottom = Dimen.highLargePadding),
            options = AppConstantsEnum.entries,
            itemWidth = Dimen.normalEditTextWidth2,
            fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
            label = Strings.current().vat,
            selectedItem = AppConstantsEnum.entries.find {
                it.value == selectedVat2
            },
            displayText = {
                if (it is AppConstantsEnum)
                    it.label else ""
            },
            onOptionClick = {
                if (it is AppConstantsEnum)
                    updateVatCode2(it.value)


            }
        )
    }


}